/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getMessageList: (params) => {
    return axios.get(API_ENDPOINTS.GET_MESSAGES_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getMessageById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_MESSAGES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteMessage: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_MESSAGES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
